// src/components/common/MapWithPin.tsx
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix default marker icon issue with Webpack/Vite
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

interface MapWithPinProps {
  lat: number;
  lng: number;
  label?: string;
  height?: string;
  zoom?: number;
  className?: string;
}

const MapWithPin: React.FC<MapWithPinProps> = ({ 
  lat, 
  lng, 
  label, 
  height = '300px', 
  zoom = 15,
  className = ''
}) => {
  const position: [number, number] = [lat, lng];

  return (
    <div className={`rounded-2xl overflow-hidden shadow-lg ${className}`}>
      <MapContainer
        center={position}
        zoom={zoom}
        scrollWheelZoom={false}
        style={{ height, width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>{label || 'Selected Location'}</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default MapWithPin;
